/**
 * Production module permission keys.
 * Keep in sync with backend role definitions.
 */
export const PRODUCTION_PERMISSIONS = {
  BOM_READ: "production:bom:read",
  BOM_CREATE: "production:bom:create",
  BOM_UPDATE: "production:bom:update",

  BOM_VERSION_READ: "production:bom-version:read",
  BOM_VERSION_CREATE: "production:bom-version:create",
  BOM_VERSION_UPDATE: "production:bom-version:update",
  BOM_VERSION_SUBMIT: "production:bom-version:submit",
  BOM_VERSION_APPROVE: "production:bom-version:approve",
  BOM_VERSION_REJECT: "production:bom-version:reject",
  BOM_VERSION_ACTIVATE: "production:bom-version:activate",
  BOM_VERSION_ARCHIVE: "production:bom-version:archive",

  PLAN_READ: "production:plan:read",
  PLAN_CREATE: "production:plan:create",
  PLAN_UPDATE: "production:plan:update",
  PLAN_SUBMIT: "production:plan:submit",
  PLAN_APPROVE: "production:plan:approve",
  PLAN_REQUEST_ISSUANCE: "production:plan:request-issuance",
  PLAN_CANCEL: "production:plan:cancel",

  ORDER_READ: "production:order:read",
  ORDER_CREATE: "production:order:create",
  ORDER_UPDATE: "production:order:update",
  ORDER_SUBMIT_QC: "production:order:submit-qc",
  ORDER_APPROVE_QC: "production:order:approve-qc",
  ORDER_CANCEL: "production:order:cancel"
} as const

export type ProductionPermission = (typeof PRODUCTION_PERMISSIONS)[keyof typeof PRODUCTION_PERMISSIONS]
